import React from "react"
import Shimmer from "./Shimmer"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"

const getOfferKey = (count) => {
  if (count === 1) return "offer_count_one"
  if (count > 1 && count < 5) return "offer_count_few"
  return "admin.offer_count_many"
}

const ResultsBar = ({ count, isLoading }) => {
  const { t } = useTranslation()
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="flex items-center justify-between"
    >
      <div className="flex items-center gap-2">
        {isLoading ? (
          <Shimmer className="h-6 w-32 rounded-lg" />
        ) : (
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-lg bg-app-base-strong text-white text-xs font-bold shadow-sm shadow-app-base-strong/30">
              {count}
            </span>
            <span className="text-sm font-medium text-app-content-subtle">
              {t(getOfferKey(count), { count })}
            </span>
          </div>
        )}
      </div>
    </motion.div>
  )
}

export default ResultsBar
